import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { squadApi } from "../api/squad.js";
export function RuleEditor({ onClose }) {
    const [data, setData] = useState(null);
    const [selected, setSelected] = useState([]);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);
    useEffect(() => {
        squadApi.getRules().then(r => {
            setData(r);
            setSelected(r.activeRuleIds);
        }).catch(e => setError(e.message));
    }, []);
    function toggle(id) {
        setSelected(prev => prev.includes(id) ? prev.filter(x => x !== id) : prev.length < 5 ? [...prev, id] : prev);
    }
    async function save() {
        setSaving(true);
        try {
            await squadApi.setRules(selected);
            onClose();
        }
        catch (e) {
            setError(e.message);
        }
        finally {
            setSaving(false);
        }
    }
    if (error)
        return (_jsxs("div", { style: { padding: 16, color: "#ef4444" }, children: [_jsx("button", { onClick: onClose, style: { background: "none", border: "none", color: "#64748b", cursor: "pointer", marginBottom: 8 }, children: "\u2190 Back" }), _jsx("div", { children: error })] }));
    if (!data)
        return (_jsx("div", { style: { padding: 16, color: "#64748b", display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }, children: "Loading rules\u2026" }));
    return (_jsxs("div", { style: { padding: 16, display: "flex", flexDirection: "column", gap: 12, overflowY: "auto" }, children: [_jsxs("div", { style: { display: "flex", alignItems: "center", justifyContent: "space-between" }, children: [_jsx("button", { onClick: onClose, style: { background: "none", border: "none", color: "#64748b", fontSize: 13, cursor: "pointer", padding: 0 }, children: "\u2190 Cancel" }), _jsxs("span", { style: { color: "#94a3b8", fontSize: 12, fontWeight: 600 }, children: ["RULES (", selected.length, "/5)"] }), _jsx("button", { onClick: save, disabled: saving, style: {
                            background: "#7c3aed", color: "#fff", border: "none", borderRadius: 8,
                            padding: "6px 14px", fontSize: 12, fontWeight: 600,
                            cursor: saving ? "default" : "pointer", opacity: saving ? 0.7 : 1,
                        }, children: saving ? "Saving…" : "Save" })] }), _jsx("div", { style: { color: "#475569", fontSize: 11 }, children: "Pick 1-5 rules. They fire in order (top = first). Rules activate next battle." }), _jsx("div", { style: { display: "flex", flexDirection: "column", gap: 8 }, children: data.palette.map((rule, i) => {
                    const isActive = selected.includes(rule.id);
                    const order = selected.indexOf(rule.id) + 1;
                    const disabled = !isActive && selected.length >= 5;
                    return (_jsxs("div", { onClick: () => !disabled && toggle(rule.id), style: {
                            background: isActive ? "#7c3aed18" : "#12121a",
                            border: `1px solid ${isActive ? "#7c3aed66" : "#1e293b"}`,
                            borderRadius: 10,
                            padding: "10px 12px",
                            display: "flex", alignItems: "center", gap: 10,
                            cursor: disabled ? "default" : "pointer",
                            opacity: disabled ? 0.4 : 1,
                            transition: "all 0.15s",
                        }, children: [_jsx("div", { style: {
                                    width: 22, height: 22, borderRadius: 6, flexShrink: 0,
                                    background: isActive ? "#7c3aed" : "#1e293b",
                                    color: isActive ? "#fff" : "#334155",
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                    fontSize: 11, fontWeight: 700,
                                }, children: isActive ? order : i + 1 }), _jsx("div", { style: { flex: 1, color: isActive ? "#a78bfa" : "#475569", fontSize: 12 }, children: rule.label }), isActive && (_jsx("div", { style: { color: "#7c3aed", fontSize: 16 }, children: "\u2713" }))] }, rule.id));
                }) })] }));
}
